// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardV1CreatePrescriberDefaultResponse {
    static getAttributeTypeMap() {
        return CardV1CreatePrescriberDefaultResponse.attributeTypeMap;
    }
}
CardV1CreatePrescriberDefaultResponse.discriminator = undefined;
CardV1CreatePrescriberDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ICreatePrescriberResponseModel"
    }
];
//# sourceMappingURL=cardV1CreatePrescriberDefaultResponse.js.map